export default __webpack_public_path__ + "static/media/landing.3fd1e620.png";